<template>
  <div>
    <b-modal
      id="modal-idle"
      ref="modalIdle"
      cancel-title="Log me out"
      cancel-variant="outline-secondary"
      centered
      no-close-on-backdrop
      size="md"
      ok-title="I'm still here"
      title="Your session is about to expire!"
      @ok="cancelIdleness"
      @cancel="onLogout"
    >
      <!-- <div>
        <span>Are you still here?</span>
      </div> -->
      <div class="p-2">
        <p>Hi {{ fullName || userData ? userData.username : '' }}, if your profile is still inactive in  5-minutes time, you will be logged out !</p>
        <p>{{ time }} second left</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import { modalMixins } from '@core/mixins/modal'
import { mapGetters } from 'vuex'
import { initialAbility } from '@/libs/acl/config'

export default {
  components: {
    BModal,
  },
  mixins: [modalMixins],
  props: {
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      time: 30,
      timer: '',
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
    fullName() {
      if (this.userData) {
        return `${this.userData?.firstname} ${this.userData?.lastname}`
      }
      return ''
    },
  },
  watch: {
    isActive(newValue) {
      if (newValue && !this.isOpen) {
        this.showModal('modal-idle')
        this.isOpen = true
        this.countDownTimer()
      }
    },
  },
  methods: {
    onLogout() {
      this.hideModal('modal-idle')
      this.$store.dispatch('auth/logout')
      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
    countDownTimer() {
      this.timer = setInterval(() => {
        if (this.time > 0) {
          // eslint-disable-next-line no-plusplus
          this.time--
        } else {
          clearInterval(this.timer)
          // Your logout function should be over here
          this.onLogout()
        }
      }, 1000)
    },
    cancelIdleness() {
      this.hideModal('modal-idle')
      clearInterval(this.timer)
      this.isOpen = false
      this.time = 30
    },
  },
}
</script>
